import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy3 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    var pack = document.querySelector("#pp").value;
    var direct = document.querySelector("#direct").value;
    var level = document.querySelector("#level").value;
    var wid = document.querySelector("#wid").value;
    var i =0;
    const refer = document.querySelector("#hid").value;
    var a1 = document.querySelector("#tt2").value;
    console.log(name, contract);
    console.log(refer);
    var a = document.querySelector("#test").value;
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const addr = document.querySelector("#us").value;
    function refreshPage() {
      window.location.reload(false);
    }
    const addressOfYourContract = '0x8e1858e5fabae5b2f084dd892aab33bdf07ad835';
    const amountInTheSmallestUnit = ("000000000000000000");
  
     const busdContractAddress = '0xf09a02b39e22EB7D60B17070012297Ee0478a0f1';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    
    console.log(addr);
    

    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
    /*
if(addr=="0x0b15F4dbb00ABc232fcA1a54aF1bdd829E7eb68E")
{

}
  else if(addr="0xC7CeFCD51616B42f447A208b6cf8331cd9754036") 
  {

  }
  else
  { 
    */
  console.log('hello');
  console.log(pack/10);
  console.log(a);
  console.log(wid);
  console.log(direct);
  console.log(level);
 
  if(a > 0 && a < (pack/10))
           {
              i = (pack/10) - wid;
            }
/*
if(pack > 99 && pack < 500 && direct > 199 && level > 399 && a < 251 && a >0)
{
           i=250-wid;
}
else if(pack > 99 && pack < 500 && a < 101 && a >0)
{
             i=100-wid;
  
}

if(pack > 499 && pack < 1000 && direct > 599 && level > 1499 && a < 501 && a >0)
{
    i=500-wid;        
}

else if(pack > 499 && pack < 1000 && direct > 199 && level > 399 && a < 251 && a >0)
{
  i=250-wid;
}
else if(pack > 499 && pack < 1000 && a < 101 && a >0)
{
              i=100-wid;
  
}
 
if(pack > 999 && pack < 5250 && direct > 1599 && level > 3499 && a < 1001 && a > 0)
{
              i=1000-wid;
}
else if(pack > 999 && pack < 5250 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
             i=500-wid;
}

else if(pack > 999 && pack < 5250 && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 999 && pack < 5250 && a < 101 && a >0)
{
              i=100-wid;
  
}

if(pack > 5249 && pack < 10000 && direct > 1899 && level > 4999 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 5249 && pack < 10000 && direct > 1599 && level > 3499 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 5249 && pack < 10000 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 5249 && pack < 10000 && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 5249 && pack < 10000 && a < 101 && a >0)
{
                 i=100-wid;
  
}
  
if(pack > 9999 && pack < 30000 && direct > 2199 && level > 6999 && a < 1999 && a >0)
{
             i=2000-wid;
}

else if(pack > 9999 && pack < 30000 && direct > 1899 && level > 4999 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 9999 && pack < 30000 && direct > 1599 && level > 3499 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 9999 && pack < 30000 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 9999 && pack < 30000 && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 9999 && pack < 30000 && a < 101 && a >0)
{
                 i=100-wid;
  
}

if(pack > 29999 && pack < 60000 && direct > 3199 && level > 17999 && a < 3999 && a >0)
{
             i=4000-wid;
}

else if(pack > 29999 && pack < 60000 && direct > 2199 && level > 6999 && a < 1999 && a >0)
{
             i=2000-wid;
}

else if(pack > 29999 && pack < 60000 && direct > 1899 && level > 4999 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 29999 && pack < 60000 && direct > 1599 && level > 3499 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 29999 && pack < 60000 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 29999 && pack < 60000 && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 29999 && pack < 60000 && a < 101 && a >0)
{
                 i=100-wid;
  
}

if(pack > 59999 && pack < 100000 && direct > 4199 && level > 59999 && a < 8001 && a >0)
{
             i=8000-wid;
}

else if(pack > 59999 && pack < 100000 && direct > 3199 && level > 17999 && a < 4001 && a >0)
{
             i=4000-wid;
}

else if(pack > 59999 && pack < 100000 && direct > 2199 && level > 6999 && a < 2001 && a >0)
{
             i=2000-wid;
}

else if(pack > 59999 && pack < 100000 && direct > 1899 && level > 4999 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 59999 && pack < 100000 && direct > 1599 && level > 3499 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 59999 && pack < 100000 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 59999 && pack < 100000 && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 59999 && pack < 100000 && a < 101 && a >0)
{
                 i=100-wid;
  
}

if(pack > 99999  && direct > 5999 && level > 149999 && a < 12001 && a >0)
{
             i=12000-wid;
}

else if(pack > 99999  && direct > 4199 && level > 59999 && a < 8001 && a >0)
{
             i=8000-wid;
}

else if(pack > 99999   && direct > 3199 && level > 17999 && a < 4001 && a >0)
{
             i=4000-wid;
}

else if(pack > 99999   && direct > 2199 && level > 6999 && a < 2001 && a >0)
{
             i=2000-wid;
}

else if(pack > 99999  && direct > 1899 && level > 4999 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 99999  && direct > 1599 && level > 3499 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 99999 && direct > 599 && level > 1499 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 99999  && direct > 199 && level > 399 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 99999  && a < 101 && a >0)
{
                 i=100-wid;
  
}
*/

if(i < a)
{

}
else
{

      const transaction = await contract.withdraw(addr,a, {
          gasLimit: 900000,
      });
  
  
      await transaction.wait();
  
      console.log("Transaction is done");
}
  
/*
if(a>9)
 {
      const transaction = await contract.withdraw(addr,a, {
          gasLimit: 900000,
      });
  
  
      await transaction.wait();
     
      console.log("Transaction is done");
 }                                                                                      
*/                                                                                                                               
   
   refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
     
        <form onSubmit={buyChai}>
        
        
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <button
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
   style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Withdraw
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy3;